import React from 'react';
import { Grid, Card, CardContent, CardMedia, Typography, Pagination, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { generatePlaceholderImage } from '../utils/imageUtils';
import { useMeta } from '../contexts/MetaContext';

const ProductGrid = ({ products, view, page, setPage }) => {
  const { metaData } = useMeta();
  const productsPerPage = 48;
  const getGridColumns = (breakpoint) => {
    if (breakpoint === 'xs') {
      return view === 'large' ? 12 : 6;
    } else if (breakpoint === 'sm') {
      return view === 'compact' ? 4 : view === 'large' ? 12 : 6;
    }
    
    return view === 'large' ? 6 : view === 'compact' ? 3 : 4;
  };

  const paginatedProducts = products.slice((page - 1) * productsPerPage, page * productsPerPage);

  return (
    <>
      <Grid container spacing={4}>
        {paginatedProducts.map((product) => (
          <Grid item xs={getGridColumns('xs')} sm={getGridColumns('sm')} md={getGridColumns('md')} lg={getGridColumns('lg')} key={product.id}>
            <Card 
              component={Link} 
              to={`/product/${product.id}`} 
              sx={{ 
                textDecoration: 'none',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  '& .secondary-image': {
                    opacity: 1,
                  },
                },
                boxShadow: 'none',
                p: 1,
                textAlign: 'center', // Center all card content
              }}
            >
              <Box sx={{ position: 'relative', paddingTop: '100%' }}>
                <CardMedia 
                  component="img" 
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                  src={`${metaData.imageCdn}/img/product/${product.id}/1.jpg`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = generatePlaceholderImage(300, 300, product.name);
                  }}
                  alt={product.name}
                />
                {product.meta?.ic > 1 && (
                  <CardMedia 
                    component="img" 
                    className="secondary-image"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      opacity: 0,
                      transition: 'opacity 0.3s ease-in-out',
                    }}
                    src={`${metaData.imageCdn}/img/product/${product.id}/2.jpg`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = generatePlaceholderImage(300, 300, `${product.name} 2`);
                    }}
                    alt={`${product.name} - secondary view`}
                  />
                )}
              </Box>
              <CardContent sx={{ flexGrow: 1, p: 1 }}>
                <Typography 
                  variant="caption"
                  color="text.secondary" 
                  gutterBottom 
                  sx={{ textTransform: 'uppercase' }}
                >
                  {product.brand}
                </Typography>
                <Typography 
                  gutterBottom 
                  variant="subtitle1"
                  component="div" 
                  noWrap
                >
                  {product.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ${product.price}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination 
          count={Math.ceil(products.length / productsPerPage)} 
          page={page} 
          onChange={(_, value) => setPage(value)} 
          color="primary" 
        />
      </Box>
    </>
  );
};

export default ProductGrid;